// Checkout hijack for the custom discount system.
// Only fires when window.customCouponState.active is true (set by cart-coupon.js).
// Coexists with the inline Neptune bundle validator in sections/cart-drawer.liquid —
// we check the bundle rule here too so we never ship a draft order with a violation.

(() => {
  if (window.__customCheckoutHijackInstalled) return;
  window.__customCheckoutHijackInstalled = true;

  const API_BASE = 'https://fjwsowluunpjkevxrfcm.supabase.co/functions/v1';

  // Mirrors the rule in sections/cart-drawer.liquid (inline bundle validator).
  const NEPTUNE_MAIN = 'selbstreinigendes-katzenklo-neptune';
  const NEPTUNE_DEPENDENT = 'neptune-abfallbeutel-rabatt';

  function countByHandle(items, handle) {
    return items
      .filter((i) => i.handle === handle)
      .reduce((sum, i) => sum + i.quantity, 0);
  }

  function showCheckoutError(button, message) {
    // Reuse the coupon error slot if present; otherwise fall back to alert.
    const errEl = document.querySelector('cart-coupon .coupon-error');
    if (errEl) {
      errEl.textContent = message;
      errEl.style.display = 'block';
      setTimeout(() => {
        errEl.style.display = 'none';
      }, 5000);
    } else {
      alert(message);
    }
    if (button) {
      button.disabled = false;
      const btnText = button.querySelector('.btn-text');
      if (btnText && btnText.dataset.originalText) {
        btnText.textContent = btnText.dataset.originalText;
      }
    }
  }

  function setCheckoutLoading(button) {
    if (!button) return;
    button.disabled = true;
    const btnText = button.querySelector('.btn-text');
    if (btnText) {
      if (!btnText.dataset.originalText) {
        btnText.dataset.originalText = btnText.textContent;
      }
      btnText.textContent = 'Preparing checkout…';
    }
  }

  document.addEventListener(
    'click',
    async (e) => {
      const btn = e.target.closest('.js-checkout-cart-drawer');
      if (!btn) return;
      // Another handler (e.g. bundle validator) already blocked — don't fight it.
      if (e.defaultPrevented) return;
      // No custom coupon → let native Shopify flow run untouched.
      if (!window.customCouponState || !window.customCouponState.active) return;

      e.preventDefault();
      setCheckoutLoading(btn);

      try {
        const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
        const cart = await cartRes.json();

        // Respect the Neptune bundle rule — Shopify doesn't enforce it server-side,
        // so skipping this check would let customers complete checkout with a violation.
        const mainQty = countByHandle(cart.items, NEPTUNE_MAIN);
        const dependentQty = countByHandle(cart.items, NEPTUNE_DEPENDENT);
        if (dependentQty > mainQty) {
          showCheckoutError(
            btn,
            'Please adjust your Neptune bundle quantities before checking out.'
          );
          return;
        }

        const res = await fetch(`${API_BASE}/create-draft-order`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            code: window.customCouponState.code,
            cart,
          }),
        });

        const data = await res.json();
        if (!res.ok || !data.checkout_url) {
          showCheckoutError(
            btn,
            data.message || 'Could not start checkout. Please try again.'
          );
          return;
        }

        window.location.href = data.checkout_url;
      } catch (err) {
        console.error('Custom checkout hijack failed:', err);
        showCheckoutError(btn, 'Could not reach the checkout service. Please try again.');
      }
    },
    false // bubble phase — fires after any handlers attached directly to the button
  );
})();
